import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabItem } from '../models/common.model';
import { PermissionService } from '../../services/permission.service';

@Component({
  template: '',
})
export abstract class AbstractTabComponent implements OnInit {
  abstract tabs: TabItem[];
  abstract selectedTab: string;

  protected permissionService = inject(PermissionService);

  protected constructor(
    protected route: ActivatedRoute,
    protected router: Router
  ) {}

  ngOnInit() {
    this.filterTabs();

    this.route.queryParams.subscribe(params => {
      const tab = params['tab'];
      if (!tab || !this.isValidTab(tab)) {
        if (this.tabs.length > 0) {
          const firstTab = this.tabs[0].value;
          this.selectedTab = firstTab;
          // Optionally update URL to reflect first tab
          void this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab: firstTab },
            queryParamsHandling: 'merge',
            replaceUrl: true,
          });
        }
      } else {
        this.selectedTab = tab;
      }
    });
  }

  private filterTabs(): void {
    this.tabs = this.tabs.filter(t => {
      if (!t.permissionCode) return true; // If no code specified, show by default (or you could hide it)
      return this.permissionService.hasPermission(t.permissionCode);
    });
  }

  selectTab(tab: string): void {
    if (!this.isValidTab(tab)) return;

    this.selectedTab = tab;

    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  protected isValidTab(tab: string): boolean {
    return this.tabs.some(t => t.value === tab);
  }
}
